import { render } from "./ControlMultiselect.vue?vue&type=template&id=e11007b8&ts=true&lang=pug"
import script from "./ControlMultiselect.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlMultiselect.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__